import { getSessionStorage, setSessionStorage } from '@/common/sessionStorages';
import { TWithdrawAuthenticationStatus } from '@/modules/fundTransfer/types';

export const setMelliWithdrawAuthenticationStatus = (
  status: TWithdrawAuthenticationStatus
) => {
  setSessionStorage('MelliWithdrawAuthenticationStatus', status);
};

export const MelliWithdrawAuthenticationStatus = () =>
  getSessionStorage('MelliWithdrawAuthenticationStatus');

export const resetMelliWithdrawAuthentication = () => {
  // Resets the Melli authentication status, ensuring
  // that the authentication prompt is shown to the user again.
  setMelliWithdrawAuthenticationStatus(null);
};
